import { useMutation } from "@apollo/client/react";import { useMemo } from 'react';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { AdvertenciaChip } from './AdvertenciaChip';

import { FORZAR_CIERRE_PERIODO } from '../../../data/graphQL/mutations/Periodos/forzarCierrePeriodo';
import toast from 'react-hot-toast';

export const ConexionesPendientesDialog = ({ open, onClose, conexionesPendientes, getPeriodos }) => {

  const initialColumns = [
  {
    flex: 500,
    field: 'cantidad',
    headerName: 'Cantidad'
  },
  {
    flex: 500,
    field: 'delegacion',
    headerName: 'Delegacion'
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), []);

  const handleClose = () => {
    onClose();
  };

  const [forzarCierre, { loading: loadingForzarCierre }] = useMutation(FORZAR_CIERRE_PERIODO, {
    fetchPolicy: 'no-cache'
  });

  const handleForzarCierre = async () => {
    try {
      const { data } = await forzarCierre();
      if (data?.forzarCierrePeriodo?.success) {
        toast.success('El proceso puede tardar unos minutos, se le notificará vía mail el resultado de la operación.');
      } else {
        toast.error('Ocurrió un error al intentar forzar el cierre del periodo.');
      }
      await getPeriodos();
    } catch (error) {
      toast.error('Error al forzar el cierre del periodo.');
    } finally {
      handleClose();
    }
  };

  return (
    <CustomDialog
      maxWidth='md'
      fullWidth
      onCancel={() => handleClose()}
      onAccept={() => handleForzarCierre()}
      acceptLoading={loadingForzarCierre}
      cancelLoading={loadingForzarCierre}
      open={open}
      cancelText='Cancelar'
      acceptText='Forzar Cierre'
      title={'Conexiones sin justificar'}>
      
            <AdvertenciaChip
        text={'No se puede cerrar el período porque hay conexiones pendientes de facturar.'} />
      
            <DataGridGenerico
        columns={columns}
        totalCount={conexionesPendientes?.length || 0}
        rows={conexionesPendientes}
        toolbar={false} />
      
        </CustomDialog>);

};